export default __webpack_public_path__ + "static/media/F0000.ccbb3b38.png";